"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexadecimal = void 0;
const assertString_1 = require("./util/assertString");
const hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
function isHexadecimal(str) {
    (0, assertString_1.assertString)(str);
    return hexadecimal.test(str);
}
exports.isHexadecimal = isHexadecimal;
